/* quick-add-card.js — size selection + size chart for cards tagged `quick-add`.
   Pairs with snippets/quick-add-card.liquid.

   Deliberately thin: adding to cart is left to the theme's own <product-form>
   custom element, so the cart drawer, loader state and error handling are the
   theme's. All this does is move the selection onto the hidden variant input,
   and serve the size chart drawer.

   Everything is delegated off document, so cards injected later (collection AJAX
   filtering, recently-viewed, quick-view) work with no re-init. */
(function () {
  'use strict';

  /* ---------- size selection ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qa-size]');
    if (!btn) return;

    var root = btn.closest('[data-qa]');
    if (!root) return;

    root.querySelectorAll('[data-qa-size]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var input = root.querySelector('[data-qa-variant]');
    if (input) input.value = btn.getAttribute('data-variant-id');
  });

  /* ---------- size chart drawer ---------- */
  var drawer, overlay, body, cache = {};

  function build() {
    if (drawer) return;

    overlay = document.createElement('div');
    overlay.className = 'qa-chart-overlay';

    drawer = document.createElement('div');
    drawer.className = 'qa-chart';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Size chart');
    drawer.innerHTML =
      '<div class="qa-chart__head"><span>Size chart</span>' +
      '<button type="button" class="qa-chart__close" aria-label="Close">&times;</button></div>' +
      '<div class="qa-chart__body"></div>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    body = drawer.querySelector('.qa-chart__body');

    overlay.addEventListener('click', close);
    drawer.querySelector('.qa-chart__close').addEventListener('click', close);
  }

  function open() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Same page-scrape the sale-page cards use: size charts are authored as pages,
  // and the useful markup sits under one of these containers.
  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('size-chart')
      || doc.querySelector('.size-wrapper')
      || doc.querySelector('.page__content')
      || doc.querySelector('.rte')
      || doc.querySelector('article');
    return el ? el.innerHTML : '<p>Size chart unavailable.</p>';
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-qa-chart]');
    if (!trigger) return;
    e.preventDefault();

    var handle = trigger.getAttribute('data-qa-chart');
    build();
    open();

    if (cache[handle]) { body.innerHTML = cache[handle]; return; }

    body.innerHTML = '<p>Loading size chart…</p>';
    fetch('/pages/' + handle)
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.text();
      })
      .then(function (html) {
        cache[handle] = extract(html);
        body.innerHTML = cache[handle];
      })
      .catch(function () {
        body.innerHTML = '<p>Size chart unavailable. <a href="/pages/' + handle + '">Open the full page</a>.</p>';
      });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
